export const SOCIAL_KINDS = [
  { id: 'telegram', label: 'Telegram', placeholder: 'https://t.me/kanal' },
  { id: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/hesap' },
  { id: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@kanal' },
  { id: 'kick', label: 'Kick', placeholder: 'https://kick.com/kanal' },
];

export const socialIconSrc = (kind) => {
  const known = SOCIAL_KINDS.some((k) => k.id === kind);
  return `/icons3d/${known ? kind : 'telegram'}.png`;
};

export const socialLabel = (s) => (
  s?.label || SOCIAL_KINDS.find((k) => k.id === s?.kind)?.label || s?.kind || 'Sosyal'
);

export const socialHref = (url) => {
  const u = String(url || '').trim();
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('//')) return `https:${u}`;
  return `https://${u}`;
};

export const socialLink = (s) => {
  const raw = String(s?.url || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('//')) return socialHref(raw);
  if (/^(t\.me|telegram\.me|www\.instagram\.com|instagram\.com|www\.youtube\.com|youtube\.com|youtu\.be|kick\.com)\b/i.test(raw)) {
    return socialHref(raw);
  }
  const handle = raw.replace(/^@/, '');
  const map = {
    telegram: `https://t.me/${handle}`,
    instagram: `https://www.instagram.com/${handle}`,
    youtube: `https://www.youtube.com/@${handle}`,
    kick: `https://kick.com/${handle}`,
  };
  return map[s?.kind] || socialHref(raw);
};

const handleFromUrl = (url) => {
  try {
    const u = new URL(socialHref(url));
    const segs = u.pathname.split('/').filter(Boolean);
    let h = segs[0] || '';
    if (['c', 'channel', 'user', 'u'].includes(h.toLowerCase())) h = segs[1] || h;
    h = decodeURIComponent(h).replace(/\/+$/, '');
    return h || '';
  } catch (_) {
    return '';
  }
};

export const socialHandle = (s) => {
  const raw = String(s?.label || '').trim();
  if (raw) return raw;
  const fromUrl = handleFromUrl(s?.url);
  if (fromUrl) return fromUrl;
  return SOCIAL_KINDS.find((k) => k.id === s?.kind)?.label || '';
};

export const activeSocials = (site) => (
  Array.isArray(site?.socials) ? site.socials.filter((s) => String(s?.url || '').trim()) : []
);
